import React from "react";

interface RequiredLabelProps {
  children: React.ReactNode;
  required?: boolean;
  htmlFor?: string;
}

const RequiredLabel: React.FC<RequiredLabelProps> = ({
  children,
  required = false,
  htmlFor,
}) => (
  <label htmlFor={htmlFor}>
    {children}
    {required && <span className="required-mark"> *</span>}
  </label>
);

export default RequiredLabel;